import { gql } from '@apollo/client';

export const MA_OPPORTUNITIES_FILTERS_SUMMARY_QUERY = gql`
  query maOpportunitiesSummary {
    maOpportunitiesSummary {
      minValuation
      maxValuation
      minReserves
      maxReserves
      minProduction
      maxProduction
      minEmissions
      maxEmissions
    }
  }
`;
